// core version + pagination modules:
import Swiper from 'swiper';
import { Autoplay, Pagination } from 'swiper/modules';

// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/pagination';

const swiperEl = document.querySelector( '.gallery-carousel .swiper' );
if ( swiperEl ) {
	const isAutoplay = swiperEl.dataset.autoplay === 'true';
	const perSlides = parseInt( swiperEl.dataset.slides, 10 ) || 2;
	// eslint-disable-next-line no-unused-vars
	new Swiper( swiperEl, {
		// configure Swiper to use modules.
		modules: [ Pagination, Autoplay ],
		// Default parameters.
		autoplay: isAutoplay ? { delay: 3500, disableOnInteraction: true } : false,
		slidesPerView: perSlides,
		speed: 400,
		loop: true,
		pagination: {
			clickable: true,
			el: '.swiper-pagination',
		},
		spaceBetween: 24,
		// Responsive breakpoints.
		breakpoints: {
			0: {
				slidesPerView: 1,
			},
			768: {
				slidesPerView: perSlides,
			},
		},
	} );
}
